import { Trans, useTranslation } from 'react-i18next';

import { Illustration } from '../Illustration/Illustration';
import { ExternalLink } from '../Link/ExternalLink';
import { Text } from '../Text/Text';
import { Title } from '../Title/Title';
import { fullscreenStyle, illustrationStyle, textStyle, titleStyle, wrapperStyle } from './ErrorScreen.css';

export const ErrorScreen = () => {
  const { t } = useTranslation(['common']);

  return (
    <div className={fullscreenStyle}>
      <Illustration className={illustrationStyle} name="Error" strokeWidth={1.8} />

      <div className={wrapperStyle}>
        <Title as="h1" className={titleStyle}>
          {t('common:errors.global.title')}
        </Title>

        {/* TODO: add correct externalLink here */}
        <Text className={textStyle}>
          <Trans components={{ email: <ExternalLink /> }} i18nKey="common:errors.global.text" />
        </Text>
      </div>
    </div>
  );
};
